"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var locale = {
    placeholder: '请选择时间',
    rangePlaceholder: ['开始时间', '结束时间'],
};
exports.default = locale;
//# sourceMappingURL=zh_CN.js.map